require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-balad-ep.json") })
        }
      }, "path---feature-balad-ep");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-balad-ep!./.cache/json/feature-balad-ep.json
// module id = 636
// module chunks = 231608221292675